import React, { Component } from "react";
import {
  Select,
  Radio,
  Space,
  message,
  Spin,
  Checkbox,
  Input,
  RadioGroup,
} from "antd";
import Bridge from "../../../../utils/Bridge";
import { RESEARCH_TYPE } from "../../../../utils/consts";

const { Option } = Select;
const { TextArea } = Input;

export default class LanguageEducation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      highest_education: "",
      spanish_literacy: "",
      english_literacy: "",
      is_english_first_language: "",
      if_not_english_first_language: "",
      if_not_english_first_language_other: "",
      education_other_specification: "",
    };
  }
  componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    this.get_demographic_details();
  }
  get_demographic_details = () => {
    let params = "?eals_id=" + localStorage.getItem("ap_eals_id");
    Bridge.demographics.le_study
      .get(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.status == "1") {
          if (response.data.length > 0) {
            for (let item of response.data) {
              if (item.field == "Is English your first language") {
                this.setState({ is_english_first_language: item.value });
              }
              if (
                item.field == "If not English your first language, Language"
              ) {
                this.setState({ if_not_english_first_language: item.value });
              }
              if (
                item.field ==
                "If not English your first language, Language - Specification"
              ) {
                this.setState({
                  if_not_english_first_language_other: item.value,
                });
              }
              if (item.field == "Spanish Literacy") {
                this.setState({ spanish_literacy: item.value });
              }
              if (item.field == "English Literacy") {
                this.setState({ english_literacy: item.value });
              }
              if (item.field == "Highest level of education") {
                this.setState({ highest_education: item.value });
              }
              if (item.field == "Highest level of education - Specification") {
                this.setState({ education_other_specification: item.value });
              }
            }
          }
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  save = () => {
    if (!this.state.is_english_first_language) {
      message.warning("Is English your first language field is required");
      return;
    }
    if (!this.state.spanish_literacy) {
      message.warning("Spanish literacy is required");
      return;
    }
    if (!this.state.english_literacy) {
      message.warning("English literacy is required");
      return;
    }
    if (!this.state.highest_education) {
      message.warning("Highest level of education field is required");
      return;
    }
    let questions = [
      {
        parent_field: "Is English your first language",
        field: "Is English your first language",
        value: this.state.is_english_first_language,
      },
      {
        parent_field: "If not English your first language, Language",
        field: "If not English your first language, Language",
        value: this.state.if_not_english_first_language,
      },
      {
        parent_field:
          "If not English your first language, Language - Specification",
        field: "If not English your first language, Language - Specification",
        value: this.state.if_not_english_first_language_other,
      },
      {
        parent_field: "Spanish Literacy",
        field: "Spanish Literacy",
        value: this.state.spanish_literacy,
      },
      {
        parent_field: "English Literacy",
        field: "English Literacy",
        value: this.state.english_literacy,
      },
      {
        parent_field: "Highest level of education",
        field: "Highest level of education",
        value: this.state.highest_education,
      },
      {
        parent_field: "Highest level of education - Specification",
        field: "Highest level of education - Specification",
        value: this.state.education_other_specification,
      },
    ];
    let params = {
      eals_id: localStorage.getItem("ap_eals_id"),
      data: JSON.stringify(questions),
      step: "3",
      action_type: this.props.is_update == true ? "update" : "insert",
    };
    this.setState({ loading: true });
    Bridge.demographics.le_study
      .save(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.data.status == "1") {
          message.success(response.data.message);
          this.setState(
            {
              loading: false,
            },
            () => {
              if (this.props.is_update == true) {
                setTimeout(() => {
                  window.location.assign("/about-me");
                }, 3000);
              } else {
                this.props.set_active_step(5);
              }
            }
          );
        } else {
          message.error(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  render() {
    return (
      <div>
        <div className="header">
          <h3>LANGUAGE, EDUCATION AND OCCUPATION</h3>
          <div className="white-block"></div>
        </div>
        <Spin spinning={this.state.loading}>
          <div className="form-fields">
            <div className="form-group">
              <label className="input-heading">
                Is English your first language?{" "}
                <span className="text-danger">*</span>
              </label>
              <br />
              <Radio.Group
                onChange={(e) =>
                  this.setState({
                    is_english_first_language: e.target.value,
                    if_not_english_first_language: "",
                    if_not_english_first_language_other: "",
                  })
                }
                value={this.state.is_english_first_language}
                direction="vertical"
              >
                <Space direction="horizontal">
                  <Radio value={"Yes"}>Yes</Radio>
                  <Radio value={"No"}>No</Radio>
                </Space>
              </Radio.Group>{" "}
              <br />
              {this.state.is_english_first_language == "No" && (
                <>
                  <label className="input-heading mt-2 mb-0">
                    If No English your first language, Language{" "}
                    <span className="text-danger">*</span>
                  </label>
                  <br />
                  <Select
                    onChange={(value) =>
                      this.setState({
                        if_not_english_first_language: value,
                        if_not_english_first_language_other: "",
                      })
                    }
                    value={this.state.if_not_english_first_language}
                    className="col-lg-12 mt-3"
                    style={{
                      width: "100%",
                      height: 55,
                      maxWidth: 500,
                    }}
                  >
                    <Option value="">Select Language:</Option>
                    <Option value="Arabic">Arabic</Option>
                    <Option value="French">French</Option>
                    <Option value="German">German</Option>
                    <Option value="Hindi">Hindi</Option>
                    <Option value="Japanese">Japanese</Option>
                    <Option value="Korean">Korean</Option>
                    <Option value="Mandarin">Mandarin</Option>
                    <Option value="Portuguese">Portuguese</Option>
                    <Option value="Spanish">Spanish</Option>
                    <Option value="Russian">Russian</Option>
                    <Option value="Urdu">Urdu</Option>
                    <Option value="Other">Other</Option>
                  </Select>
                </>
              )}
              {this.state.if_not_english_first_language == "Other" && (
                <>
                  <br />
                  <label className="input-heading mb-0 mt-2">
                    Other Language <span className="text-danger">*</span>
                  </label>
                  <br />
                  <input
                    type="text"
                    name="if_not_english_first_language_other"
                    placeholder="Enter Language"
                    className="mt-3"
                    value={this.state.if_not_english_first_language_other}
                    onChange={(e) => {
                      this.setState({
                        if_not_english_first_language_other: e.target.value,
                      });
                    }}
                  />
                </>
              )}
            </div>
            <div className="form-group">
              <label className="input-heading">
                Spanish Literacy <span className="text-danger">*</span>
              </label>
              <br />
              <Radio.Group
                onChange={(e) =>
                  this.setState({
                    spanish_literacy: e.target.value,
                  })
                }
                value={this.state.spanish_literacy}
                direction="vertical"
              >
                <Space direction="horizontal">
                  <Radio value={"Yes"}>Yes</Radio>
                  <Radio value={"No"}>No</Radio>
                </Space>
              </Radio.Group>
            </div>
            <div className="form-group">
              <label className="input-heading">
                English Literacy <span className="text-danger">*</span>
              </label>
              <br />
              <Radio.Group
                onChange={(e) =>
                  this.setState({
                    english_literacy: e.target.value,
                  })
                }
                value={this.state.english_literacy}
                direction="vertical"
              >
                <Space direction="horizontal">
                  <Radio value={"Yes"}>Yes</Radio>
                  <Radio value={"No"}>No</Radio>
                </Space>
              </Radio.Group>
            </div>
            <div className="form-group">
              <label className="input-heading">
                Highest level of education?{" "}
                <span className="text-danger">*</span>
              </label>
              <br />
              <Radio.Group
                onChange={(e) =>
                  this.setState({
                    highest_education: e.target.value,
                    education_other_specification: "",
                  })
                }
                value={this.state.highest_education}
                direction="vertical"
              >
                <Space direction="vertical">
                  <Radio value={"No formal education"}>
                    No formal education
                  </Radio>
                  <Radio value={"Elementary School"}>Elementary School</Radio>
                  <Radio value={"High school graduate / GED"}>
                    High school graduate / GED
                  </Radio>
                  <Radio value={"Some college, no degree"}>
                    Some college, no degree
                  </Radio>
                  <Radio
                    value={"Associate degree, vocational school, or equivalent"}
                  >
                    Associate degree, vocational school, or equivalent
                  </Radio>
                  <Radio value={"Bachelor's degree"}>Bachelor's degree</Radio>
                  <Radio value={"Master's degree"}>Master's degree</Radio>
                  <Radio value={"Doctorate or Ph.D."}>Doctorate or Ph.D.</Radio>
                  <Radio value={"Other"}>Other</Radio>
                </Space>
              </Radio.Group>
              {this.state.highest_education == "Other" && (
                <div>
                  <label className="input-heading mt-2 mb-2">
                    Specification
                  </label>
                  <br />
                  <TextArea
                    style={{
                      padding: 16,
                      fontSize: 18,
                    }}
                    rows={4}
                    placeholder="Specification..."
                    name="education_other_specification"
                    value={this.state.education_other_specification}
                    onChange={(e) => {
                      this.setState({
                        education_other_specification: e.target.value,
                      });
                    }}
                  />
                </div>
              )}
            </div>
            {this.props.is_update == true ? (
              <div className="d-flex mt-5">
                <button
                  className="submit-button"
                  style={{
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save()}
                >
                  Save{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            ) : (
              <div className="d-flex mt-5">
                <button
                  style={{
                    padding: "9px 28px 10px 21px",
                  }}
                  className="submit-button"
                  onClick={() => this.props.set_active_step(3)}
                >
                  <box-icon
                    name="chevron-left"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                  Previous
                </button>
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 17,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save()}
                >
                  Save & Next{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            )}
          </div>
        </Spin>
      </div>
    );
  }
}
